/* eslint 'jsx-a11y/anchor-is-valid': 'off', eqeqeq: 'off'  */
import React, { Component } from 'react';
import { connect } from "react-redux";
import SearchInput, { createFilter } from 'react-search-input';
import { Table } from 'reactstrap';
import { BuildingAssociation } from '../../../../action/workorderAction';

const KEYS_TO_FILTERS = ['Name','FloorName','Location'];
class MultiSelectSearchableDropDown extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
        }
        this.searchUpdated = this.searchUpdated.bind(this);
    }

    searchUpdated(term) {
        this.setState({ searchTerm: term })
    }

    SaveAllAssociation(){
        let SelectedNodes = [];
        var checkboxes = document.getElementsByClassName('CommonIndividualCheckbox');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked) {
                var item = checkboxes[i].name.split('~');
                var item1 = {
                    "BuildingId": item[0],
                    "FloorId": item[4],
                    "SpaceId": item[1],
                    "TenantId": item[6]
                }
                SelectedNodes.push(item1);
            }
        }
        if(SelectedNodes.length){
            const actionResponse = this.props.BuildingAssociation(SelectedNodes);
            actionResponse.then((result) => {
                this.props.setValue();
            });
        }
    }

    selectAllOption() {
        var checkboxes = document.getElementsByClassName('CommonIndividualCheckbox');
        var main_Check_box = document.getElementsByClassName('CommonHeaderCheckbox');
        for (var i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = main_Check_box[0].checked ? true : false;
        }        
    }
    ResetHeaderCheckBox(){
        var IsAnyChecked = true;
        var checkboxes = document.getElementsByClassName('CommonIndividualCheckbox');
        var header_Check_box = document.getElementsByClassName('CommonHeaderCheckbox');
        for (var i = 0; i < checkboxes.length; i++) {
          if(!checkboxes[i].checked)
            IsAnyChecked = false;
        }
        IsAnyChecked ? header_Check_box[0].checked = true : header_Check_box[0].checked = false;
    }

    render(){
        var data = this.props.data;
        let FilteredData, Tenants;

        if (data != undefined && data.length > 0 && data != null) {
            FilteredData = data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            if (FilteredData.length != 0) {
                Tenants = FilteredData.map((el,index) =>(
                    <tr key={el.Id}>
                        <th style={{width:"5%", bordertop: "0 solid"}}>
                            <input type="checkbox" id={'chkAssociate_'+index} name={el.BuildingId+'~'+el.Id+'~'+el.Name+'~'+el.FloorName+'~'+el.FloorId+'~'+el.BuildingName+'~'+el.TenantId} className="CommonIndividualCheckbox" onChange={() => { this.ResetHeaderCheckBox() }} />
                        </th>
                        {
                            el.FloorName !== "" ? el.Name !== "" ? 
                            <td style={{width:"50%", bordertop: "0 solid"}}>{el.Name}<b> {'-->'}  </b>{el.FloorName}</td> :
                            <td style={{width:"50%", bordertop: "0 solid"}}>{el.FloorName}</td> : 
                            <td style={{width:"50%", bordertop: "0 solid"}}>{el.Name}</td>
                        }
                    </tr>
                    ));
                }
            else {
                Tenants = <tr><td colSpan="3">No Records found</td></tr>
            }
        }
        else {
               Tenants = <tr><td colSpan="3">No Records found</td></tr>
        }

        return(
            <div ref={this.props.refMethod} style={this.props.elementStyle}>
            <SearchInput className="search-input" onChange={this.searchUpdated} style={{width:"370px",float:"right","margin-top":"5px","margin-bottom":"5px","margin-left":"6px","margin-right":"6px",height:'40px'}} />
                <Table style={{ bordertop: "0 solid" }}>
                    <tbody>
                        <tr>
                            <td><input type="checkbox" className="CommonHeaderCheckbox" onChange={() => { this.selectAllOption() }} /></td>
                            <td>Select All
                            <a className="nv_link link_cursor" style={{"width":"35px","float":"right"}} onClick={() => { this.SaveAllAssociation()}}>Submit</a>
                            </td>
                        </tr>
                        {Tenants}
                    </tbody>
                </Table>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
    };
};
const mapDispatchToProps = dispatch => {
    return {
        BuildingAssociation: (data) => dispatch(BuildingAssociation(data))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(MultiSelectSearchableDropDown);